/* Mike's Liquors — Deposit Sync (externalized from theme.liquid for performance, 2026-06-01).
   Loaded via <script src defer>. Reads window.MIKES_* deposit globals set inline in theme.liquid.
   Logic is byte-identical to the prior inline v3.20 block. */
/* === Mike's Liquors — Deposit Sync (v3.22: return panel no longer injects on an empty cart — it was latching onto a recommendation card's /cart/add form and floating over "You may also like"; anchor chain now cart-section-scoped; v3.21: atomic cart-change rewrite falls back to triggers() so stale variant lists can't deadlock keg quantity changes; v3.20: +$50 coupler-rental deposit, tub deposit removed) — regenerated from deposits.js === */
(function mikesDeposits() {
  'use strict';

  // ── Config ────────────────────────────────────────────────────────
  // Build the deposit list from whatever variant ids Liquid injected. Each
  // entry: {id, price, label, handleMatch, productTypeMatch}. A cart item
  // is a "trigger" for the deposit if handleMatch matches item.handle OR
  // productTypeMatch(item.product_type) returns true.
  var DEPOSITS = [];

  // Kegs from these vendors ship in one-way, non-refundable plastic kegs and
  // take NO deposit despite product_type "Keg" (Health-Ade, Stumptown, GT's). Keyed
  // by vendor (not variant id) so any future flavor of these brands is covered.
  // Must mirror cart-validation/run.js NO_DEPOSIT_KEG_VENDORS.
  var MIKES_NO_DEPOSIT_KEG_VENDORS = ['health-ade', 'stumptown coffee', "gt's living foods"];

  // Gas refills (CO₂ / Nitrogen / Nitro-CO₂ mix) are sold as FILLED tanks, each
  // carrying a $100 refundable tank deposit. Detect by productType === "Gas Refill"
  // so ANY current or future refill SKU is covered — the old exact-handle match
  // (`item.handle === 'co2-refill'`) silently missed duplicate/replacement refill
  // products and they sold the tank with no deposit (see LESSONS 2026-06-05). Then
  // map to the correct tank deposit by gas type. ORDER MATTERS: test 'mix' before
  // 'co2'/'n2' because the mix product's name contains both "CO₂" and "Nitro".
  function mikesGasRefillType(item) {
    if (typeof item.product_type !== 'string' ||
        item.product_type.toLowerCase().indexOf('gas refill') === -1) return null;
    var s = ((item.sku || '') + ' ' + (item.handle || '') + ' ' +
             (item.product_title || item.title || '')).toLowerCase();
    if (s.indexOf('mix') !== -1) return 'mix';
    if (s.indexOf('co2') !== -1 || s.indexOf('co₂') !== -1) return 'co2';
    if (s.indexOf('nitro') !== -1 || s.indexOf('n2') !== -1) return 'n2';
    return null;
  }

  if (window.MIKES_KEG_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_KEG_DEPOSIT_VARIANT,
      price: 50,
      label: 'keg deposit',
      // Keg trigger is product_type-based for the post-mutation poller
      // (handles edge cases where a keg lands in the cart via a path we
      // didn't atomically rewrite — e.g. a future quick-add we missed).
      triggers: function (item) {
        if (typeof item.product_type !== 'string' ||
            item.product_type.toLowerCase().indexOf('keg') === -1) return false;
        // One-way plastic kegs (Health-Ade, Stumptown) are non-refundable — no deposit.
        return MIKES_NO_DEPOSIT_KEG_VENDORS.indexOf((item.vendor || '').toLowerCase()) === -1;
      },
      // Variant ids for atomic-ATC rewrite. Populated from
      // window.MIKES_KEG_VARIANT_IDS (injected from theme.liquid). When ANY
      // /cart/add.js for a keg variant fires (Horizon's sticky bar, default
      // PDP button, collection quick-add, third-party JS), the wrapper
      // appends MIKES_KEG_DEPOSIT_VARIANT to items[] in the same call so the
      // Cart Validation Function never sees "keg present, deposit absent".
      // Regenerate this list when adding/removing keg products: query
      //   products(query:"product_type:Keg AND status:active") { variants { legacyResourceId } }
      // and embed the array in theme.liquid.
      triggerVariants: window.MIKES_KEG_VARIANT_IDS || [],
    });
  }
  if (window.MIKES_CO2_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_CO2_DEPOSIT_VARIANT,
      price: 100,
      label: 'CO₂ tank deposit',
      // Any "Gas Refill" product detected as CO₂ (see mikesGasRefillType).
      triggers: function (item) { return mikesGasRefillType(item) === 'co2'; },
      // Variant ids for atomic-ATC rewrite — co2-refill 5/10/20 lb (CO2-RFL-*).
      // Adding a new CO₂ refill SKU? The poller covers it via productType, but
      // add its variant id here too so the deposit attaches atomically on ATC.
      triggerVariants: [42961750130791, 42961750163559, 42961750196327],
    });
  }
  if (window.MIKES_N2_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_N2_DEPOSIT_VARIANT,
      price: 100,
      label: 'nitrogen tank deposit',
      triggers: function (item) { return mikesGasRefillType(item) === 'n2'; },
      // Atomic-ATC: 100% Nitro Refill 5/10/20 lb (N2-RFL-*, the live 3-size
      // product). Old single-size n2-refill (MK179, 42961766088807) kept for the
      // transition until it's archived — harmless once it's gone.
      triggerVariants: [43771527659623, 43771527692391, 43771527725159, 42961766088807],
    });
  }
  if (window.MIKES_MIX_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_MIX_DEPOSIT_VARIANT,
      price: 100,
      label: 'nitro/CO₂ mix tank deposit',
      triggers: function (item) { return mikesGasRefillType(item) === 'mix'; },
      // Atomic-ATC: Nitro CO₂ Mix Refill 5/10/20 lb (MIX-RFL-*).
      triggerVariants: [43771523498087, 43771523530855, 43771523563623],
    });
  }
  if (window.MIKES_PUMP_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_PUMP_DEPOSIT_VARIANT,
      price: 50,
      label: 'pump deposit',
      triggers: function (item) {
        return typeof item.handle === 'string' && item.handle.indexOf('pump-rent') !== -1;
      },
      triggerVariants: [
        42369284014183, // a-german-slider-pump-rent (MM71061R)
        42369284112487, // d-domestic-keg-pump-rent  (MM7509R)
        42369284145255, // s-euro-keg-pump-rent      (MM7520R)
        42442117972071, // type-d-pump-rental        (PUMP-D-RENT, keg-accessories panel)
        44464995926119, // type-s-pump-rental        (PUMP-S-RENT, keg-accessories panel)
        44464995991655, // type-a-pump-rental        (PUMP-A-RENT, keg-accessories panel)
      ],
    });
  }
  // Tub deposit restored 2026-05-25 ($20; reversed the 2026-05-24 flat-$10/no-deposit).
  if (window.MIKES_TUB_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_TUB_DEPOSIT_VARIANT,
      price: 20,
      label: 'tub deposit',
      // Only the consolidated 'keg-tub-rental' (TUB-RENT) is live; its handle
      // contains 'tub-rent'. Sale-only '19-gallon-tub' lacks 'rent'.
      triggers: function (item) {
        return typeof item.handle === 'string' && item.handle.indexOf('tub-rent') !== -1;
      },
      triggerVariants: [
        42442085302375, // keg-tub-rental (TUB-RENT, keg-accessories panel + standalone PDP)
      ],
    });
  }
  if (window.MIKES_COUPLER_DEPOSIT_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_COUPLER_DEPOSIT_VARIANT,
      price: 50,
      label: 'coupler deposit',
      // Any coupler RENTAL (coupler-rent-type-*) carries a $50 refundable deposit.
      // Coupler PURCHASES (coupler-buy-type-*) do not — 'buy' lacks 'rent'.
      triggers: function (item) {
        return typeof item.handle === 'string' && item.handle.indexOf('coupler-rent') !== -1;
      },
      triggerVariants: [
        42441839083623, // coupler-rent-type-d (CPLR-D-RENT)
        42441904652391, // coupler-rent-type-s (CPLR-S-RENT)
        42441945514087, // coupler-rent-type-u (CPLR-U-RENT)
        42441994666087, // coupler-rent-type-g (CPLR-G-RENT)
        43797682978919, // coupler-rent-type-a (CPLR-A-RENT)
      ],
    });
  }
  if (window.MIKES_JOCKEY_DEPOSIT_SINGLE_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_JOCKEY_DEPOSIT_SINGLE_VARIANT,
      price: 500,
      label: 'jockey box deposit (1 tap)',
      // Single-faucet (1-tap) jockey boxes only — handle has 'jockey-box','rent','single'.
      triggers: function (item) {
        if (typeof item.handle !== 'string') return false;
        return item.handle.indexOf('jockey-box') !== -1 &&
               item.handle.indexOf('rent') !== -1 &&
               item.handle.indexOf('single') !== -1;
      },
      triggerVariants: [
        42369284210791, // single-jockey-box-rent-without-keg (MK04)
        42442036248679, // jockey-box-single-rent             (JB-1-RENT, keg-accessories panel)
      ],
    });
  }
  if (window.MIKES_JOCKEY_DEPOSIT_DOUBLE_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_JOCKEY_DEPOSIT_DOUBLE_VARIANT,
      price: 500,
      label: 'jockey box deposit (2 tap)',
      // Double-faucet (2-tap) jockey boxes only — handle has 'jockey-box','rent','double'.
      triggers: function (item) {
        if (typeof item.handle !== 'string') return false;
        return item.handle.indexOf('jockey-box') !== -1 &&
               item.handle.indexOf('rent') !== -1 &&
               item.handle.indexOf('double') !== -1;
      },
      triggerVariants: [
        42369284178023, // double-jockey-box-rent-without-keg (MK05)
        42442060759143, // jockey-box-double-rent             (JB-2-RENT, keg-accessories panel)
      ],
    });
  }

  // TEST-ONLY ($0.01 keg-deposit-V2 QA harness, re-added 2026-05-21). Triggers
  // exclusively on the TEST PRODUCT handle so no real product is affected. The
  // test keg's productType is "Test Product" (not "Keg"), so it does NOT fire
  // the real $50 keg deposit or the Cart Validation keg rule — only this $0.01
  // deposit attaches. Remove this block + the MIKES_KEG_DEPOSIT_V2_VARIANT
  // injection above on teardown.
  if (window.MIKES_KEG_DEPOSIT_V2_VARIANT) {
    DEPOSITS.push({
      id: window.MIKES_KEG_DEPOSIT_V2_VARIANT,
      price: 0.01,
      label: 'keg deposit (TEST)',
      triggers: function (item) { return item.handle === 'test-product'; },
      triggerVariants: [43788657459303], // test-product (TEST PRODUCT)
    });
  }

  if (DEPOSITS.length === 0) {
    console.warn('[Mikes Deposits] no deposit variant ids injected — skipping');
    return;
  }

  var POLL_INTERVAL_MS = 12000; // safety-net backstop only (primary sync is event/fetch-driven); 3s→12s to cut idle /cart.js polling on every page — 2026-06-13 perf
  var RESYNC_DEBOUNCE_MS = 250;

  // ── State ─────────────────────────────────────────────────────────
  // One entry per deposit. `lineKey` is the Shopify line key
  // ("variantId:propsHash") — refreshed each sync so we can self-identify
  // our own /cart/change.js posts and skip the resync loop for them.
  var state = DEPOSITS.map(function (d) {
    return {
      id: d.id,
      price: d.price,
      label: d.label,
      triggers: d.triggers,
      lineKey: null,
      lastTriggerCount: 0,
      lastDepositCount: 0,
    };
  });

  var syncInProgress = false;
  var resyncNeeded = false;
  var pendingSyncTimer = null;
  var pollTimer = null;

  // ── Helpers ───────────────────────────────────────────────────────
  function isOnCheckoutPath() {
    // Shopify's hosted checkout lives at /checkouts/<token>. theme.liquid
    // is normally not loaded there, but this guard also covers the
    // transition window and any Plus-merchant Checkout Extensibility surface.
    return /^\/checkouts?\//.test(window.location.pathname);
  }

  function cartFetch() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function cartAdd(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });
  }

  function cartChange(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  function cartUpdateAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function dispatchCartRefresh() {
    // Horizon's cart-items / cart-summary / cart-drawer components listen for
    // 'cart:update' (colon, with detail.data.sections payload). Verified at
    // theme/assets/events.js:14 (`cartUpdate = 'cart:update'`). With an empty
    // sections object, Horizon falls back to fetching fresh section HTML via
    // sectionRenderer.renderSection. Without this dispatch, the cart drawer
    // stays stuck on its last render and the deposit silently doesn't appear.
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        sourceId: 'mikes-deposits',
        data: { source: 'mikes-deposits', sections: {} }
      }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));
  }

  function showToast(message) {
    var existing = document.getElementById('mikes-deposit-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'mikes-deposit-toast';
    t.setAttribute('role', 'status');
    t.style.cssText =
      'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);' +
      'background:#1a3a5c;color:#fff;padding:13px 22px;border-radius:6px;' +
      'font-size:14px;line-height:1.4;z-index:99999;box-shadow:0 4px 16px rgba(0,0,0,0.35);' +
      'max-width:92vw;text-align:center;pointer-events:none';
    t.textContent = message;
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 5000);
  }

  // ── Deposit sync ──────────────────────────────────────────────────
  // One pass: fetch cart, compute desired deposit quantity per deposit type,
  // apply adjustments sequentially. Sequential (not parallel) because Shopify
  // cart API is single-threaded per session — parallel mutations race and
  // one silently overwrites the other.
  function syncDeposits() {
    if (isOnCheckoutPath()) return Promise.resolve();
    if (syncInProgress) {
      resyncNeeded = true;
      return Promise.resolve();
    }
    syncInProgress = true;
    resyncNeeded = false;

    return cartFetch()
      .then(function (cart) {
        // Reset per-deposit counters and find our deposit lines in the cart
        state.forEach(function (s) { s.triggerCount = 0; s.depositLine = null; });

        cart.items.forEach(function (item) {
          state.forEach(function (s) {
            if (item.variant_id === s.id) {
              s.depositLine = item;
            } else if (s.triggers(item)) {
              s.triggerCount += item.quantity;
            }
          });
        });

        // Snapshot line key and counts for selfMutation detection
        state.forEach(function (s) {
          s.lineKey = s.depositLine ? s.depositLine.key : null;
          s.lastDepositCount = s.depositLine ? s.depositLine.quantity : 0;
          s.lastTriggerCount = s.triggerCount;
        });

        // Build adjustments — apply sequentially
        var chain = Promise.resolve();
        state.forEach(function (s) {
          var current = s.depositLine ? s.depositLine.quantity : 0;
          var diff = s.triggerCount - current;
          if (diff === 0) return;
          chain = chain.then(function () {
            if (diff > 0) {
              return cartAdd(s.id, diff).then(function () {
                showToast(
                  diff > 1
                    ? diff + ' × $' + s.price + ' refundable ' + s.label + 's added to your cart.'
                    : 'A $' + s.price + ' refundable ' + s.label + ' has been added to your cart.'
                );
              });
            }
            // diff < 0 → trim
            var newQty = current + diff;
            return cartChange(s.depositLine.key, newQty).then(function () {
              if (newQty === 0) showToast(capitalize(s.label) + ' removed.');
            });
          });
        });

        return chain.then(dispatchCartRefresh);
      })
      .catch(function (e) {
        console.warn('[Mikes Deposits] sync error:', e);
      })
      .then(function () {
        syncInProgress = false;
        if (resyncNeeded) {
          resyncNeeded = false;
          scheduleSync();
        }
      });
  }

  function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function scheduleSync() {
    if (pendingSyncTimer) clearTimeout(pendingSyncTimer);
    pendingSyncTimer = setTimeout(function () {
      pendingSyncTimer = null;
      syncDeposits();
    }, RESYNC_DEBOUNCE_MS);
  }

  // ── Atomic ATC rewrite ────────────────────────────────────────────
  // Cart Validation Functions run at every cart mutation, not just at
  // checkout. If a customer adds a CO₂ refill via the PDP ATC button, the
  // validator sees `refill present, deposit absent` and blocks the call —
  // even though our deposit-sync loop is about to add the deposit.
  //
  // Fix: intercept /cart/add.js BEFORE it fires and append the matching
  // deposit to the items[] in the same request. The cart never enters an
  // invalid state, so the validator passes on the first try.
  //
  // Handles both body shapes:
  //   • JSON string `{id, quantity, properties}` or `{items: [...]}`
  //   • FormData (Horizon's PDP ATC uses this; gets converted to JSON
  //     multi-item body and Content-Type header is updated to match)
  //
  // Idempotent: deposits already present in items[] are skipped (so
  // keg-accessories.js, which builds its own multi-item body with the
  // deposit included, isn't touched).
  function maybeAtomicATCRewrite(init) {
    if (!init || !init.body) return null;

    var items = null;
    var sections = null;
    var bodyIsFormData =
      typeof FormData !== 'undefined' && init.body instanceof FormData;

    if (typeof init.body === 'string') {
      var parsed;
      try { parsed = JSON.parse(init.body); } catch (e) { return null; }
      if (Array.isArray(parsed.items)) {
        items = parsed.items.slice();
      } else if (parsed.id != null) {
        var single = { id: parsed.id, quantity: parsed.quantity || 1 };
        if (parsed.properties) single.properties = parsed.properties;
        items = [single];
      }
      if (parsed && parsed.sections) sections = parsed.sections;
    } else if (bodyIsFormData) {
      var id = init.body.get('id');
      if (id == null) return null;
      var qty = parseInt(init.body.get('quantity'), 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      var props = {};
      var hasProps = false;
      init.body.forEach(function (val, key) {
        var m = key.match(/^properties\[([^\]]+)\]$/);
        if (m) { props[m[1]] = val; hasProps = true; }
      });
      var entry = { id: id, quantity: qty };
      if (hasProps) entry.properties = props;
      items = [entry];
      sections = init.body.get('sections') || null;
    }

    if (!items || !items.length) return null;

    var presentIds = {};
    items.forEach(function (it) { presentIds[String(it.id)] = true; });

    var modified = false;
    DEPOSITS.forEach(function (d) {
      if (!d.triggerVariants || !d.triggerVariants.length) return;
      if (presentIds[String(d.id)]) return;
      var depositQty = 0;
      items.forEach(function (it) {
        var itId = Number(it.id);
        if (d.triggerVariants.indexOf(itId) !== -1) {
          depositQty += (parseInt(it.quantity, 10) || 1);
        }
      });
      if (depositQty > 0) {
        items.push({ id: d.id, quantity: depositQty });
        presentIds[String(d.id)] = true;
        modified = true;
      }
    });

    if (!modified) return null;

    var newBody = { items: items };
    if (sections) newBody.sections = sections;

    var newInit = {};
    for (var k in init) { if (init.hasOwnProperty(k)) newInit[k] = init[k]; }
    newInit.body = JSON.stringify(newBody);

    // Rebuild headers as a plain object so we can safely override Content-Type
    // (FormData posts had multipart boundary headers; we're now sending JSON).
    var newHeaders = {};
    if (init.headers) {
      if (typeof Headers !== 'undefined' && init.headers instanceof Headers) {
        init.headers.forEach(function (v, k) { newHeaders[k] = v; });
      } else if (Array.isArray(init.headers)) {
        init.headers.forEach(function (pair) { newHeaders[pair[0]] = pair[1]; });
      } else {
        for (var hk in init.headers) {
          if (init.headers.hasOwnProperty(hk)) newHeaders[hk] = init.headers[hk];
        }
      }
    }
    newHeaders['Content-Type'] = 'application/json';
    newHeaders['X-Requested-With'] = 'XMLHttpRequest';
    newInit.headers = newHeaders;

    return newInit;
  }

  // ── Atomic /cart/change rewrite ────────────────────────────────────
  // When a customer bumps a keg/refill quantity from the cart-page UI,
  // Horizon fires /cart/change with just the trigger line's new qty. The
  // resulting cart would be unbalanced (more triggers than deposits) —
  // the validator 422s it before deposits.js's poller can reconcile.
  //
  // Two body formats to handle:
  //   1. /cart/change.js (third-party / programmatic): {id: lineKey, quantity}
  //   2. /cart/change   (Horizon's cart UI):           {line: 1BasedIndex, quantity, sections, sections_url}
  //
  // Fix: detect either format, resolve to the actual line, and replay as
  // a single /cart/update.js that updates BOTH the trigger AND the deposit
  // line in one mutation. Validator runs once on the final balanced state
  // and approves.
  //
  // Returns:
  //   • null if no rewrite needed (caller falls through to _origFetch)
  //   • Promise<Response> if we rewrote — the promise resolves to the
  //     /cart/update.js Response (or to a passthrough _origFetch when the
  //     line isn't a trigger or the cart was pre-invalid)
  function maybeAtomicCartChangeRewrite(resource, init) {
    if (!init || !init.body || typeof init.body !== 'string') return null;
    var parsed;
    try { parsed = JSON.parse(init.body); } catch (e) { return null; }

    var newQty = parseInt(parsed.quantity, 10);
    if (isNaN(newQty)) return null;

    var lineKeyHint = parsed.id != null ? String(parsed.id) : null;
    var lineIndexHint = null;
    if (parsed.line != null) {
      var idx = parseInt(parsed.line, 10);
      if (!isNaN(idx)) lineIndexHint = idx;
    }
    if (!lineKeyHint && lineIndexHint == null) return null;

    // Commit to async path: either we rewrite to /cart/update.js, or we
    // fall back via _origFetch with the original args. Either way, return
    // a Promise<Response> so the caller (Horizon) gets a Response.
    return cartFetch().then(function (cart) {
      var triggerLine = null;
      if (lineKeyHint) {
        for (var k = 0; k < cart.items.length; k++) {
          if (cart.items[k].key === lineKeyHint) { triggerLine = cart.items[k]; break; }
        }
      } else if (lineIndexHint != null && lineIndexHint >= 1 && lineIndexHint <= cart.items.length) {
        triggerLine = cart.items[lineIndexHint - 1];
      }
      if (!triggerLine) return _origFetch(resource, init);

      var triggerVariantId = triggerLine.variant_id;
      var lineKey = triggerLine.key;

      var matchingDeposit = null;
      for (var i = 0; i < DEPOSITS.length; i++) {
        var d = DEPOSITS[i];
        if (d.triggerVariants && d.triggerVariants.indexOf(triggerVariantId) !== -1) {
          matchingDeposit = d;
          break;
        }
      }
      if (!matchingDeposit) {
        // Fallback: the hardcoded triggerVariants lists go stale as kegs are
        // added (newer kegs missing -> raw /cart/change.js -> CVF 422 -> the
        // quantity button silently does nothing). Match by the same triggers()
        // predicate the poller trusts. Never treat a deposit line itself as a
        // trigger (variant-id match against DEPOSITS is checked first).
        var isDepositLine = false;
        for (var j = 0; j < DEPOSITS.length; j++) {
          if (DEPOSITS[j].id === triggerVariantId) { isDepositLine = true; break; }
        }
        if (!isDepositLine) {
          for (var j2 = 0; j2 < DEPOSITS.length; j2++) {
            if (DEPOSITS[j2].triggers(triggerLine)) { matchingDeposit = DEPOSITS[j2]; break; }
          }
        }
      }
      if (!matchingDeposit) return _origFetch(resource, init);

      var newTriggerCount = 0;
      var depositLine = null;
      cart.items.forEach(function (item) {
        if (item.variant_id === matchingDeposit.id) {
          depositLine = item;
          return;
        }
        if (item.key === lineKey) {
          newTriggerCount += newQty;
        } else if (matchingDeposit.triggers(item)) {
          newTriggerCount += item.quantity;
        }
      });

      if (!depositLine && newTriggerCount > 0) {
        // Cart was already invalid (trigger present, deposit missing).
        // Can't /cart/update.js a non-existent line. Let the original
        // 422 surface — the imbalance was pre-existing.
        return _origFetch(resource, init);
      }

      var updates = {};
      updates[lineKey] = newQty;
      if (depositLine) updates[depositLine.key] = newTriggerCount;

      // Preserve sections/sections_url from the original request so
      // Horizon re-renders the cart-section HTML correctly.
      var updateBody = { updates: updates };
      if (parsed.sections) updateBody.sections = parsed.sections;
      if (parsed.sections_url) updateBody.sections_url = parsed.sections_url;

      return _origFetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(updateBody)
      }).then(function (response) {
        dispatchCartRefresh();
        return response;
      });
    });
  }

  // ── Fetch wrapper (primary trigger) ───────────────────────────────
  // Availability note: this wraps EVERY fetch on the storefront (Klaviyo,
  // pixels, search-as-you-type, etc). The whole body is inside try/catch so a
  // pathological Request/init shape or unexpected getter error can't break
  // every fetch on the site — worst case we fail to schedule one resync and
  // log a warning. `result` is always returned unchanged.
  var _origFetch = window.fetch.bind(window);
  window.fetch = function (resource, init) {
    var preUrl = typeof resource === 'string'
      ? resource
      : (resource && resource.url) || '';

    // Atomic /cart/change rewrite — bypass _origFetch entirely if we
    // rewrote (the rewrite already issues its own _origFetch under the hood).
    // Matches both /cart/change.js (programmatic, lineKey body) and /cart/change
    // (Horizon UI, line-index body).
    try {
      if (/\/cart\/change(\.js)?(\?|$)/.test(preUrl) && !isOnCheckoutPath()) {
        var rewrittenChange = maybeAtomicCartChangeRewrite(resource, init);
        if (rewrittenChange) return rewrittenChange;
      }
    } catch (e) {
      console.warn('[Mikes Deposits] atomic-change-rewrite:', e);
    }

    // Atomic-ATC rewrite must mutate `init` BEFORE _origFetch fires.
    try {
      if (/\/cart\/add(\.js)?(\?|$)/.test(preUrl) && !isOnCheckoutPath()) {
        var rewritten = maybeAtomicATCRewrite(init);
        if (rewritten) init = rewritten;
      }
    } catch (e) {
      console.warn('[Mikes Deposits] atomic-rewrite:', e);
    }

    var result = _origFetch(resource, init);
    try {
      var url = typeof resource === 'string'
        ? resource
        : (resource && resource.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);

      if (isCartMutation && !isOnCheckoutPath()) {
        // Skip resync if this mutation is FROM us (avoid infinite loop).
        // cart/add.js posts {items:[{id: variantId}]} — match by variant id.
        // cart/change.js posts {id: lineKey} where lineKey is "variantId:propsHash"
        //   — match by cached deposit line key OR by "variantId:" prefix for
        //   any of our deposit variant ids.
        var selfMutation = false;
        try {
          if (init && init.body && typeof init.body === 'string') {
            var parsed = JSON.parse(init.body);
            var ids = [];
            if (parsed.id != null) ids.push(String(parsed.id));
            if (parsed.items) parsed.items.forEach(function (i) { ids.push(String(i.id)); });

            outer:
            for (var i = 0; i < ids.length; i++) {
              var id = ids[i];
              for (var j = 0; j < state.length; j++) {
                var s = state[j];
                var depositVar = String(s.id);
                if (id === depositVar) { selfMutation = true; break outer; }
                if (s.lineKey && id === String(s.lineKey)) { selfMutation = true; break outer; }
                if (id.indexOf(depositVar + ':') === 0) { selfMutation = true; break outer; }
              }
            }
          }
        } catch (e) { /* FormData body — can't inspect, assume not ours */ }

        // v3.19 guard: an attribute/note-only /cart/update.js (body carries
        // `note`/`attributes` but no `updates`/`items`/`id`) never touches line
        // items, so it cannot unbalance deposits. Skip the resync — otherwise it
        // forces a needless cart re-render that resets in-cart widgets mid-edit
        // (e.g. the delivery-date picker: lost summary + unsaved instructions).
        var attrOrNoteOnly = false;
        try {
          if (/\/cart\/update(\.js)?/.test(url) && init && init.body && typeof init.body === 'string') {
            var pu = JSON.parse(init.body);
            if (!pu.updates && !pu.items && pu.id == null) attrOrNoteOnly = true;
          }
        } catch (e) { /* not JSON — leave guard off */ }

        // Schedule sync AFTER the fetch completes (whatever the response type)
        result.finally(function () {
          if (!selfMutation && !attrOrNoteOnly) scheduleSync();
        });
      }
    } catch (e) {
      console.warn('[Mikes Deposits] fetch wrap:', e);
    }
    return result;
  };

  // ── Polling safety net ────────────────────────────────────────────
  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      if (document.hidden) return;
      if (isOnCheckoutPath()) return;
      cartFetch().then(function (cart) {
        // Refresh line keys (for selfMutation detection accuracy) and check
        // whether any deposit is out of sync
        var needsSync = false;
        state.forEach(function (s) {
          var triggerCount = 0;
          var depositLine = null;
          cart.items.forEach(function (item) {
            if (item.variant_id === s.id) depositLine = item;
            else if (s.triggers(item)) triggerCount += item.quantity;
          });
          s.lineKey = depositLine ? depositLine.key : null;
          var current = depositLine ? depositLine.quantity : 0;
          if (triggerCount !== current) needsSync = true;
        });
        if (needsSync) scheduleSync();
      }).catch(function () {});
    }, POLL_INTERVAL_MS);
  }

  // ── Deposit locks ──────────────────────────────────────────────────
  // CSS removes qty/delete controls on each deposit line (display:none). If
  // anything ever bypasses the CSS, the JS click-lock below catches the click
  // and syncDeposits() restores the qty on the next tick.
  // Horizon-specific selectors: cart rows carry `data-key="VID:propsHash"`
  // rather than `data-variant-id`, so we match by `data-key^="VID:"`. We keep
  // `[data-variant-id="VID"]` too for non-Horizon theme compatibility.
  var lockSelectors = [];
  state.forEach(function (s) {
    var idStr = String(s.id);
    var horizonRow = 'tr[data-key^="' + idStr + ':"]';
    var legacyRow = '[data-variant-id="' + idStr + '"]';
    lockSelectors.push(
      horizonRow + ' cart-quantity-selector-component',
      horizonRow + ' input[name="updates[]"]',
      horizonRow + ' .cart-items__remove',
      horizonRow + ' [aria-label*="Remove"]',
      horizonRow + ' [aria-label*="remove"]',
      legacyRow + ' quantity-input',
      legacyRow + ' .cart-remove-button',
      legacyRow + ' [aria-label*="Remove"]',
      legacyRow + ' [aria-label*="remove"]'
    );
  });
  var lockStyle = document.createElement('style');
  var afterRules = state.map(function (s) {
    var idStr = String(s.id);
    return (
      'tr[data-key^="' + idStr + ':"] .cart-items__title::after,' +
      '[data-variant-id="' + idStr + '"]::after' +
      ' { content: " — Locked (refundable on return)"; font-size: 11px; color: #888; font-weight: 400; font-style: italic; letter-spacing: 0.01em; }'
    );
  }).join('\n');
  lockStyle.textContent =
    "/* Mike's — lock deposit cart lines */\n" +
    lockSelectors.join(',\n') + ' {\n' +
    '  display: none !important;\n' +
    '}\n' +
    afterRules;
  document.head.appendChild(lockStyle);

  // JS-level click lock — stops the qty-minus / remove button even if the CSS
  // pointer-events rule is overridden by a competing theme style. Covers all
  // deposit variants, per-row check by data-key prefix.
  function installClickLock() {
    document.addEventListener('click', function (e) {
      for (var i = 0; i < state.length; i++) {
        var idStr = String(state[i].id);
        var row = e.target.closest('tr[data-key^="' + idStr + ':"], [data-variant-id="' + idStr + '"]');
        if (!row) continue;
        var target = e.target.closest('.cart-items__remove, .quantity-minus, .cart-remove-button, [aria-label*="Remove"], [aria-label*="Decrease"]');
        if (!target) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        showToast('The ' + state[i].label + ' is locked while a matching product is in your cart.');
        return;
      }
    }, true);
  }
  installClickLock();

  // ── Return credit UI ──────────────────────────────────────────────
  // Panel on the cart page for customers to declare returning empties. Stored
  // in cart attributes and rolled into the displayed refund total. Store
  // staff process the actual refund on receipt of the physical items.
  var RETURN_LINES = [
    { key: 'keg',  label: 'Empty kegs',          attr: 'Returning Empty Kegs',      price: 50,  max: 20 },
    { key: 'co2',  label: 'Empty CO₂ tanks',     attr: 'Returning CO2 Tanks',       price: 100, max: 10 },
    { key: 'n2',   label: 'Empty Nitrogen tanks', attr: 'Returning Nitrogen Tanks', price: 100, max: 10 },
  ];

  function injectReturnPanel() {
    if (!/^\/cart(\/|$|\?)/.test(window.location.pathname)) return;

    // An empty cart has no checkout path, so a declared return can't ride an
    // order — and with no cart summary rendered, the anchor fallback below would
    // mis-place the panel onto a product card in the "You may also like"
    // recommendations grid (it would latch onto that card's /cart/add form).
    // Suppress it here, and remove any panel left over from when the cart still
    // had items. This is NOT cart-CONTENT gating (which we never do — returns
    // ride any delivery): it gates only on the cart being empty/uncheckoutable.
    if (document.querySelector('.cart-page--empty')) {
      var stale = document.getElementById('mikes-return-panel');
      if (stale) stale.remove();
      return;
    }

    if (document.getElementById('mikes-return-panel')) return;

    // Anchor must stay INSIDE the cart section — never the recommendations grid
    // or newsletter that follow it — so the panel can't land on a product card.
    var anchor =
      document.querySelector('cart-summary-component') ||
      document.querySelector('.cart-page__summary') ||
      document.querySelector('.cart__footer') ||
      document.querySelector('.cart-page__items') ||
      document.querySelector('.cart-page');
    if (!anchor) return;

    var rowsHtml = RETURN_LINES.map(function (r) {
      return (
        '<div class="mrp-row">' +
          '<div>' +
            '<div class="mrp-label">' + r.label + '</div>' +
            '<div class="mrp-sub">$' + r.price + ' refund each</div>' +
          '</div>' +
          '<div class="mrp-ctrl">' +
            '<select id="mikes-return-' + r.key + '">' + buildQtyOptions(r.max) + '</select>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var panel = document.createElement('aside');
    panel.id = 'mikes-return-panel';
    panel.innerHTML =
      '<style>' +
      '#mikes-return-panel{background:#fff9ee;border:1px solid #e8d4a0;border-radius:10px;padding:22px 24px;margin:20px 0;font-family:Inter,-apple-system,sans-serif;color:#3a2a0c}' +
      '#mikes-return-panel summary{font-size:15px;font-weight:700;color:#2a1a00;cursor:pointer;padding:2px 0;outline:none}' +
      '#mikes-return-panel summary:hover{color:#6b3e00}' +
      '#mikes-return-panel details:not([open])>*:not(summary){display:none}' +
      '#mikes-return-panel details>p{margin:12px 0 14px}' +
      '#mikes-return-panel p{margin:0 0 14px;font-size:13px;line-height:1.5;color:#5a4a2a}' +
      '#mikes-return-panel .mrp-row{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:10px 0;border-top:1px dashed #e8d4a0}' +
      '#mikes-return-panel .mrp-row:first-of-type{border-top:none}' +
      '#mikes-return-panel .mrp-label{font-size:14px;font-weight:600;color:#2a1a00}' +
      '#mikes-return-panel .mrp-sub{font-size:11px;color:#7a6a4a;font-weight:400;margin-top:2px}' +
      '#mikes-return-panel .mrp-ctrl{display:flex;align-items:center;gap:8px}' +
      '#mikes-return-panel select{padding:6px 10px;border:1px solid #c8b48a;border-radius:6px;background:#fff;font-size:14px;font-weight:600}' +
      '#mikes-return-panel .mrp-refund{display:block;margin-top:16px;padding-top:14px;border-top:2px solid #d4a017;font-size:14px;font-weight:700;color:#6b3e00;text-align:right}' +
      '#mikes-return-panel .mrp-refund span{color:#c97e0c;font-size:18px}' +
      '</style>' +
      '<details id="mikes-return-details">' +
        '<summary>Click here if returning kegs/gas tanks for a refund</summary>' +
        "<p>Tell us how many you're bringing back. Your refund is processed after the items are received at Mike's Liquors.</p>" +
        rowsHtml +
        '<div class="mrp-refund" id="mikes-return-total">Refund upon return: <span>$0.00</span></div>' +
      '</details>';

    anchor.parentNode.insertBefore(panel, anchor);

    // Sync-set from window cache FIRST so values survive re-injection (the
    // cart re-renders aggressively after every cartUpdateAttributes, which
    // wipes the panel; the MutationObserver re-injects, and without the cache
    // the new selects are at value 0 until cartFetch resolves — any change
    // event during that window writes 0s to the other slots and silently
    // wipes the customer's other selections).
    if (window.__mikesReturnCache) {
      RETURN_LINES.forEach(function (r) {
        var sel = document.getElementById('mikes-return-' + r.key);
        if (sel) sel.value = String(window.__mikesReturnCache[r.key] || 0);
      });
      updateReturnTotal();
    }

    // Confirm with cart attributes (source of truth) and sync the cache.
    cartFetch().then(function (cart) {
      window.__mikesReturnCache = window.__mikesReturnCache || {};
      RETURN_LINES.forEach(function (r) {
        var v = parseInt((cart.attributes || {})[r.attr] || '0', 10);
        if (isNaN(v)) v = 0;
        window.__mikesReturnCache[r.key] = v;
        var sel = document.getElementById('mikes-return-' + r.key);
        if (sel) sel.value = String(v);
      });
      updateReturnTotal();
    });

    RETURN_LINES.forEach(function (r) {
      var sel = document.getElementById('mikes-return-' + r.key);
      if (sel) sel.addEventListener('change', onReturnChange);
    });
  }

  function buildQtyOptions(max) {
    var s = '';
    for (var i = 0; i <= max; i++) s += '<option value="' + i + '">' + i + '</option>';
    return s;
  }

  function readReturnCounts() {
    var out = {};
    RETURN_LINES.forEach(function (r) {
      var sel = document.getElementById('mikes-return-' + r.key);
      out[r.key] = parseInt(sel ? sel.value : '0', 10);
      if (isNaN(out[r.key])) out[r.key] = 0;
    });
    return out;
  }

  function updateReturnTotal() {
    var counts = readReturnCounts();
    var total = RETURN_LINES.reduce(function (sum, r) { return sum + counts[r.key] * r.price; }, 0);
    var el = document.getElementById('mikes-return-total');
    if (!el) return;
    // Preserve the injected structure ("Refund upon return: <span>$X.XX</span>")
    // and only swap the numeric span's text — textContent is XSS-safe by
    // construction, whereas the previous innerHTML concat would break the
    // moment any label derived from user input landed here.
    var amountEl = el.querySelector('span');
    if (amountEl) amountEl.textContent = '$' + total.toFixed(2);
    // Auto-expand the disclosure when there's a pending return so the
    // customer never loses sight of a refund they already declared.
    // Open-only: never force-close, so a manual collapse sticks.
    if (total > 0) {
      var details = document.getElementById('mikes-return-details');
      if (details) details.open = true;
    }
  }

  function onReturnChange() {
    updateReturnTotal();
    var counts = readReturnCounts();
    // Write through the cache so re-injection sees the user's latest values
    // synchronously (avoids the wipe-on-rerender race).
    window.__mikesReturnCache = window.__mikesReturnCache || {};
    RETURN_LINES.forEach(function (r) { window.__mikesReturnCache[r.key] = counts[r.key]; });
    var attrs = {};
    RETURN_LINES.forEach(function (r) { attrs[r.attr] = String(counts[r.key]); });
    // Do NOT dispatchCartRefresh here — attribute-only changes don't affect
    // line items, and triggering Horizon's cart re-render wipes this panel
    // and forces re-injection. The panel manages its own display via
    // updateReturnTotal above; no UI re-render is needed.
    cartUpdateAttributes(attrs);
  }

  // ── Boot ─────────────────────────────────────────────────────────
  function boot() {
    if (isOnCheckoutPath()) return;
    scheduleSync();
    startPolling();
    injectReturnPanel();
    document.addEventListener('cart:refresh', injectReturnPanel);
    document.addEventListener('cart-update', injectReturnPanel);
    // Horizon's cart drawer re-mounts the summary on some flows — watch the
    // DOM and re-inject the return panel if it disappears. Cheap because the
    // check is a single getElementById.
    try {
      var mo = new MutationObserver(function () {
        if (!document.getElementById('mikes-return-panel')) injectReturnPanel();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* ignore */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
